import React from 'react';
import { Link } from 'react-router-dom';
import { MODULES } from '@/lib/modules';
import { MapPin, Mail, Globe2 } from 'lucide-react';

const COUNTRIES = [
  'Nigeria', 'Ghana', 'Kenya', 'South Africa', 'Egypt', 'Rwanda', 'Tanzania',
  'Uganda', 'Senegal', 'Côte d\'Ivoire', 'Ethiopia', 'Cameroon', 'Morocco',
];

export default function Footer() {
  return (
    <footer className="relative bg-navy text-white" data-testid="main-footer">
      <div className="absolute inset-0 bg-kente-stripes opacity-[0.07] pointer-events-none" />
      <div className="container-x py-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logos/attp-main.png" alt="" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-display text-xl font-bold">ATTP <span className="text-amber">NEXUS</span></div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/50">Run Africa, smarter.</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-sm">
              Powering organizations through smart technology systems — from operations to finance,
              from people to processes, every business function working together for measurable growth.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-amber" /> Lagos · London · Houston · Toronto</div>
              <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-amber" /> info@attpnexus.com.ng</div>
              <div className="flex items-center gap-2"><Globe2 className="w-4 h-4 text-amber" /> +234 (703) 313-7679</div>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="label-tag text-amber mb-4">All Modules</div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {MODULES.map((m) => {
                const href = m.slug === 'engineering' ? '/engineering'
                           : m.slug === 'corporate' ? '/corporate'
                           : `/m/${m.slug}`;
                return (
                  <Link
                    key={m.id}
                    to={href}
                    className="text-sm text-white/75 hover:text-amber transition-colors"
                    data-testid={`footer-module-${m.slug}`}
                  >
                    {m.short}
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-tag text-amber mb-4">Platform</div>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/login" className="hover:text-amber">Sign in</Link></li>
              <li><Link to="/control-panel" className="hover:text-amber">Control Panel</Link></li>
              <li><Link to="/dashboard/financials" className="hover:text-amber">Module Dashboard</Link></li>
              <li><a href="#pricing" className="hover:text-amber">Pricing</a></li>
              <li><a href="#presence" className="hover:text-amber">African Presence</a></li>
            </ul>
            <div className="label-tag text-amber mt-8 mb-4">Operating in</div>
            <div className="flex flex-wrap gap-1.5 text-[11px] text-white/60">
              {COUNTRIES.map((c) => (
                <span key={c} className="px-2 py-1 border border-white/15 rounded-sm">{c}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-3 text-xs text-white/50">
            <img src="/logos/oluakin-engineering.png" alt="Olu-Akintade Engineering" className="h-8 object-contain" />
            <Link to="/engineering" className="hover:text-amber transition-colors">In affiliation with Olu-Akintade Computer & Electrical Works Engineering</Link>
          </div>
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} ATTP Nexus. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
